import { parseSVG } from './svg-provider';

export const downloadSVG = (svg: string) => {

    const blob = new Blob([svg], {type : 'text/plain'});
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.title = '';
    link.download = 'art-text.svg';
    link.click();

    URL.revokeObjectURL(url);
};

export const downloadPNG = (svg: string) => {

    const $svg = parseSVG(svg);
    const $canvas = document.createElement('canvas');
    $canvas.width = $svg.width.baseVal.value;
    $canvas.height = $svg.height.baseVal.value;

    const ctx = $canvas.getContext('2d');
    if(!ctx) return;

    const data = (new XMLSerializer()).serializeToString($svg);
    const svgBlob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'});

    const DomURL = window.URL || window.webkitURL || window;
    const url = DomURL.createObjectURL(svgBlob);

    const $img = new Image();
    $img.onload = () => {
        ctx.clearRect(0, 0, $canvas.width, $canvas.height);
        ctx.drawImage($img, 0, 0);

        DomURL.revokeObjectURL(url);

        $canvas.toBlob(blob => {

            if(!blob) return;

            const pngUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = pngUrl;
            link.title = '';
            link.download = 'art-text.png';
            link.click();

            URL.revokeObjectURL(pngUrl);
        });
    };
    $img.src = url;
};
